import LoadingButton from "@mui/lab/LoadingButton";
import { Button } from "@mui/material";
import { useState } from "react";

const ToolBarItems = ({
  submitText = "Submit",
  submitColor = "primary",
  cancelText = "Cancel",
  showCancel = true,
  showSubmit = true,
  onCancel = () => {},
  onSubmit = () => {},
  style = {},
  // Kept in parity with src/components/ToolBarItems.js: per call site testids,
  // no generic default. Only pass these where a spec selects the buttons.
  submitTestId = undefined,
  cancelTestId = undefined,
}) => {
  const [loading, setLoading] = useState(false);

  return (
    <>
      <div
        style={{
          marginTop: "auto",
          display: "flex",
          justifyContent: "flex-end",
          ...style,
        }}
      >
        {!loading && showCancel && (
          <Button
            style={{ marginRight: "10px" }}
            size="small"
            disabled={loading}
            onClick={onCancel}
            data-testid={cancelTestId}
          >
            {cancelText}
          </Button>
        )}
        {showSubmit && (
          <LoadingButton
            loading={loading}
            variant="contained"
            color={submitColor}
            size="small"
            data-testid={submitTestId}
            onClick={(event) => {
              setLoading(true);
              if (onSubmit(event) === true) {
                setLoading(false);
              } else {
                setLoading(false);
              }
            }}
          >
            {submitText}
          </LoadingButton>
        )}
      </div>
    </>
  );
};

export default ToolBarItems;
